<ew-mat-dialog-custom>
  <div class="payment-custom-spread-dialog px-8 py-6 flex flex-col h-full">
    <mat-spinner *ngIf="isLoading" [diameter]="50" class="m-auto" />

    <div *ngIf="!isLoading" class="m-auto" style="padding-top: 100px">
      <div class="mb-7">
        <h1 class="text-2xl font-medium mb-1">
          {{ 'editCustomSpread:customSpread' | translate }}
        </h1>
        <p class="text-gray-600">
          {{ 'editCustomSpread:customSpreadDescription' | translate }}
        </p>
      </div>

      <form [formGroup]="spreadForm">
        <div class="mb-6">
          <label class="text-sm font-semibold" for="spread">
            {{ 'editCustomSpread:yourNewSpread' | translate }}
          </label>

          <div class="flex">
            <input
              class="font-bold text-5xl no-arrows w-[5ch]"
              mask="separator.2"
              thousandSeparator=""
              decimalMarker="."
              prefix=""
              suffix=""
              numericInput="true"
              [dropSpecialCharacters]="false"
              name="spread"
              formControlName="spread"
              placeholder="0.00"
              step="0.01"
              min="{{ minSpread }}"
              max="{{ maxSpread }}"
              required />
            <span class="flex font-bold text-5xl ml-1 mt-1">%</span>
          </div>

          <div class="flex mt-1">
            <div
              *ngIf="
                spreadForm.get('spread')?.invalid &&
                spreadForm.get('spread')?.touched
              "
              class="text-red-500 text-xs">
              <div *ngIf="spreadForm.get('spread')?.errors?.['required']">
                {{ 'shared:isRequired' | translate }}
              </div>
              <div *ngIf="spreadForm.get('spread')?.errors?.['min']">
                {{ 'settingsCustomSpread:spreadMinValue' | translate }}
              </div>
              <div *ngIf="spreadForm.get('spread')?.errors?.['max']">
                {{ 'settingsCustomSpread:spreadMaxValue' | translate }}
              </div>
              <div *ngIf="spreadForm.get('spread')?.errors?.['pattern']">
                {{ 'editCustomSpread:twoDecimals' | translate }}
              </div>
            </div>
          </div>

          <div
            *ngIf="defaultSpread !== null"
            class="text-sm text-gray-600 mt-2">
            {{ 'editCustomSpread:defaultSpread' | translate }}
            {{ defaultSpread }}%
          </div>
        </div>

        <div class="bg-orange-200 border-orange-300 mt-4 p-4 bg-amber-100 border border-amber-300 rounded-md flex items-start mb-7">
          <mat-icon class="text-amber-500 mr-2">warning</mat-icon>
          <div>
            <p class="text-sm">{{ 'editCustomSpread:applyMessage' | translate }}</p>
            <p
              *ngIf="defaultSpread !== null"
              class="text-sm text-blue-500 cursor-pointer hover:underline"
              (click)="useDefaultSpreadSettings()"
            >{{ 'editCustomSpread:useDefaultSpread' | translate }}</p>
          </div>
        </div>
      </form>

      <div class="flex justify-between">
        <button
          mat-flat-button
          color="primary"
          class="px-4"
          [disabled]="spreadForm.invalid || isProcessing"
          (click)="onSave()">
          <span *ngIf="!isProcessing">
            {{ 'editCustomSpread:save' | translate }}
          </span>
          <mat-spinner *ngIf="isProcessing" [diameter]="20" />
        </button>
      </div>
    </div>
  </div>
</ew-mat-dialog-custom>
